<svg
  icon="loader"
  [style.fontSize.px]="size()"
/>
